import { FilterBuilder } from './../../../helper/filter.builder';
import { Component, computed, effect, input, output, inject, ChangeDetectionStrategy } from '@angular/core';
import { FolderNotesDialogComponent } from '../person-notes-dialog/person-notes-dialog.component';
import { PersonNotesStore } from './person-notes.store';
import { GridInput } from '@it2go/data-grid';
import { translate } from '../../../../shared/shared.global-service';
import { contentGlobalSuccess } from '../../../content.error';
import { BaseDialogService } from '../../../../../components/kit/base-dialog/base-dialog-service';
import { CardComponent } from '../../../../../components/kit/card/card.component';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonComponent } from '../../../../../components/kit/button/button.component';
import { LinkButtonComponent } from '../../../../../components/kit/button/link-button.component';
import { ShortDatePipe } from '../../../../shared/pipes/short-date.pipe';

@Component({
    selector: 'app-person-notes',
    templateUrl: './person-notes.component.html',
    styleUrls: ['./person-notes.component.scss'],
    providers: [PersonNotesStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CardComponent,
        TranslatePipe,
        ButtonComponent,
        LinkButtonComponent,
        ShortDatePipe,
    ],
})
export class FolderNotesComponent {
    protected readonly dialogService = inject(BaseDialogService);
    protected readonly store = inject(PersonNotesStore);


    public canEdit = input(false);
    public folderId = input<number | null>();

    public created = output<string>();

    public selectedNote: { note: string; date: string, id?: number } | null = null;

    public filter = computed<GridInput>(() => FilterBuilder.filter({
        sort: {
            column: 'date',
            direction: 'DESC',
        },
        folderId: this.folderId(),
    }));

    constructor() {
        effect(async () => {
            if (!this.folderId() || !this.store.isAllowed('folderNote.read')()) return;
            const notes = await this.store.api.getFolderNotes(this.filter());
            this.selectedNote = notes?.['items']?.[0] || null;
        });
    }

    selectNote(note: { note: string; date: string }) {
        this.selectedNote = note;
    }

    startEdit(note?: any) {
        if (!this.store.isAllowed('folderNote.create')()) return;
        this.dialogService.open(FolderNotesDialogComponent, {
                maximizable: true,
                header: translate.instant('inputs.note'),
                data: {
                    note,
                    folderId: this.folderId(),
                    onSave: (savedNote: any) => this.addNewNote(savedNote),
                },
            },
        ).onClose.subscribe((it) => {
            if (it) {
                this.selectedNote = { note: it, date: new Date().toISOString() };
                this.created.emit(it);
            }
        });
    }

    async addNewNote(newNote: any) {
        this.store.api.getFolderNotes(this.filter());
        this.selectedNote = newNote;
        contentGlobalSuccess.next('common.created');
    }

}
